import { AsYouType } from 'libphonenumber-js'

$(document).ready(function () {

    function checkIfSame() {
        if (JSON.stringify(window.before_changes) !== JSON.stringify(window.after_changes)) {
            return false;
        } else {
            return true;
        }
    }

    function addFields(obj) {
        jQuery('input, textarea, select').each(function () {
            var identifier = jQuery(this).attr('name');
            var value = jQuery(this).val();
            if (jQuery(this).attr('type') === "checkbox") {
                if (jQuery(this).prop("checked") == true) {
                    obj[identifier] = "checked";
                } else {
                    obj[identifier] = "unchecked";
                }
            } else {
                obj[identifier] = value;
            }
        });
        return obj;
    }

    function doTheButtons() {
        window.after_changes = addFields({});
        if (!checkIfSame()) {
            jQuery('form').find('button[type="submit"]').removeAttr('disabled');
        } else {
            jQuery('form').find('button[type="submit"]').attr('disabled', true);
        }
        doTitle();
    }

    function doTitle() {
        if (!checkIfSame()) {
            console.log("not same");
            if (jQuery('body').find('.save-changes-message').length < 1) {
                jQuery('h5.navbar-title').append("<span class='save-changes-message'>( <i class='fas fa-exclamation-triangle text-warning'></i>" + __('Changes made, Please save the changes') + ".)</span>");
            }
        } else {
            console.log("same");
            if (jQuery('body').find('.save-changes-message').length > 0) {
                jQuery('body').find('.save-changes-message').remove();
            }
        }
    }

    if (jQuery('body').find('.admin_button_logic').length > 0) {
        jQuery('body').find('button[type="submit"]').attr('disabled', true);
        window.before_changes = addFields({});
        window.after_changes = addFields({});

        jQuery('body').on('keyup', 'input, textarea', function () {
            doTheButtons();
        });

        jQuery('body').on('change', 'input, form, file', function () {
            doTheButtons();
        });

        jQuery('body').on('click, mouseenter, mouseleave', 'select', function () {
            doTheButtons();
        });

        jQuery('body').on('mouseenter, mouseleave, mouseover', 'button[type="submit"]', function () {
            doTheButtons();
        });
    }



    if (jQuery('.admin-simple').length > 0) {

        function renderDistributorList(distributors, businessId) {
            var html = "";
            if (distributors.length > 0) {
                jQuery('.distributors-box').parent().removeClass('hidden');
                for (var i = 0; i < distributors.length; i++) {
                    html += `
                    <div class="col-sm-12 distributor-row pt-1 pb-1">
                        <div class="row align-items-center d-flex admin-simple-company-details">
                            <div class="container-fluid w-100 admin-simple-select-company d-flex">
                                <div>${distributors[i].name}</div>
                                <div>${distributors[i].phone}</div>
                                <div>${distributors[i].email}</div>
                            </div>
                            <div class="container-fluid w-100 mt-2">
                                <a href="/business/${businessId}/distributors/${distributors[i].user_id}/remove/ajax" data-id="${distributors[i].user_id}" class="btn btn-outline-primary remove-access w-100"><i class="fas fa-times-circle mr-1"></i> Remove Access</a>
                            </div>
                        </div>
                    </div>`;
                }
                jQuery('.distributors-box').html(html);
                jQuery('.business-name').text(jQuery('.select2-selection').first().text());
            } else {
                jQuery('.distributors-box').parent().addClass('hidden');
            }
        }

        var val = jQuery('.select-company').val();
        if (val) {
            jQuery.ajax("/business/" + val + "/distributors/ajax").then(
                (success) => renderDistributorList(success, val),
                (error) => console.log(error),
            );
        }


        // RTF-3975 - prevent dropdown before select2 is initialized
        function isSelect2Initialized($el) {
            return $el.hasClass('select2-hidden-accessible') && $el.next('.select2').length > 0;
        }

        const $select = $('.select-company');

        if (!isSelect2Initialized($select)) {
            $select.prop('disabled', false);
            $select.select2({
                width: "calc(100% - 50px)"
            });
        }

        $('#includeCanceledToggle').on('change', function() {
            const includeCanceled = $(this).is(':checked');

            $.ajax({
                url: '/businesses/get-list-ajax',
                type: 'GET',
                data: { includeCanceled: includeCanceled },
                success: function(data) {
                    const $select = $('.select-company');
                    $select.empty();

                    $select.append('<option></option>');

                    data.forEach(function(business) {
                        $select.append(new Option(business.name, business.business_id));
                    });

                    $select.select2({
                        placeholder: __("Select a Company"),
                        width: "calc(100% - 50px)",
                    });
                },
                error: function() {
                    alert(__('Failed to retrieve company list. Please try again.'));
                }
            });
        });


        $('.select-user').select2({
            placeholder: __("Select a Distributor"),
            width: "calc(100% - 50px)",
        });

        function escapeHtml (value) {
            return String(value == null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
        }

        // Splits a user-search result into the three display lines:
        // "Name - Title", "Business Group", "Phone - Email". Empty parts are omitted.
        function buildUserSearchLines (item) {
            var name = (item.name || '').trim()
            var title = (item.title || '').trim()
            var business = (item.business || '').trim()
            var phone = (item.phone || '').trim()
            var email = (item.email || '').trim()

            var contactParts = []
            if (phone) contactParts.push(phone)
            if (email) contactParts.push(email)

            var nameLine = title ? (name + ' - ' + title) : name
            // RTF-5236: soft-deleted accounts are marked in the results list and
            // selected-user view, immediately after the role label.
            if (item.deleted) nameLine += ' (DELETED)'

            return {
                nameLine: nameLine,
                business: business,
                contactLine: contactParts.join(' - '),
            }
        }

        // Returns a DOM node so select2 appends it directly (default escapeMarkup
        // only escapes string returns); inner text is escaped via escapeHtml.
        function formatUserResult (item) {
            if (!item.id) {
                return item.text
            }
            var parts = buildUserSearchLines(item)
            var html = ''
            if (parts.nameLine) html += '<div class="font-weight-bold">' + escapeHtml(parts.nameLine) + '</div>'
            if (parts.business) html += '<div>' + escapeHtml(parts.business) + '</div>'
            if (parts.contactLine) html += '<div>' + escapeHtml(parts.contactLine) + '</div>'
            return jQuery('<div>' + html + '</div>')
        }

        function formatUserSelection (item) {
            if (!item.id) {
                return item.text
            }
            return jQuery('<span></span>').text(buildUserSearchLines(item).nameLine || item.text || '')
        }

        $('.search-users').select2({
            placeholder: __("Search a User"),
            width: "calc(100% - 50px)",
            minimumInputLength: 2,
            templateResult: formatUserResult,
            templateSelection: formatUserSelection,
            ajax: {
                url: '/admin/users/search-ajax',
                dataType: 'json',
                delay: 300,
                data: function (params) {
                    // RTF-5236: read the checkbox at query time so it applies on the next search.
                    return {
                        search: params.term,
                        include_deleted: jQuery('#include-deleted-users').is(':checked') ? 1 : 0,
                    };
                },
                processResults: function (data) {
                    return { results: data.results };
                },
                cache: true
            }
        });

        jQuery('body').on('select2:select', '.search-users', function (e) {
            var item = e.params.data;
            var $contactSection = jQuery('.user-contact-details');
            var parts = buildUserSearchLines(item)
            var phone = (item.phone || '').trim()
            var email = (item.email || '').trim()

            $contactSection.find('.user-contact-name').text(parts.nameLine).toggle(!!parts.nameLine)
            $contactSection.find('.user-contact-business').text(parts.business).toggle(!!parts.business)

            var contactHtml = ''
            if (phone) contactHtml += escapeHtml(phone)
            if (email) {
                if (contactHtml) contactHtml += ' - '
                contactHtml += '<a href="mailto:' + escapeHtml(email) + '">' + escapeHtml(email) + '</a>'
            }
            $contactSection.find('.user-contact-contact').html(contactHtml).toggle(!!contactHtml)

            $contactSection.show();

            // RTF-5236: deleted accounts cannot be logged in as — hide the button
            // entirely (nothing is shown in its place).
            jQuery('.login-this-user-buttons').toggle(!item.deleted);
        });

        jQuery('body').on('select2:clear', '.search-users', function () {
            jQuery('.user-contact-details').hide();
            jQuery('.login-this-user-buttons').show();
        });

        jQuery('body').on('click', '.copy-user-contact-btn', function (e) {
            e.preventDefault();
            var $section = jQuery('.user-contact-details');
            var lines = [];
            var name = $section.find('.user-contact-name').text().trim();
            var business = $section.find('.user-contact-business').text().trim();
            var contact = $section.find('.user-contact-contact').text().trim()

            if (name) lines.push(name);
            if (business) lines.push(business);
            if (contact) lines.push(contact)

            navigator.clipboard.writeText(lines.join('\n'));
        });

        $('.select-msa').select2({
            placeholder: __("Select Business Group"),
            width: "calc(100% - 50px)",
        });

        jQuery('body').on('click', '.select-business-button', function (e) {
            e.preventDefault();
            var val = jQuery('.select-company').val();
            if (val) {
                window.location = "/view-as-business/login/" + val;
            }
        });

        jQuery('body').on('click', '.login-this-user-button', function (e) {
            e.preventDefault();
            var val = jQuery('.search-users').val();
            if (val) {
                window.location = `/view-as-user/login/${val}`;
            }
        });

        jQuery('body').on('change', '.select-company', function () {
            var val = jQuery('.select-company').val();
            jQuery.ajax("/business/" + val + "/distributors/ajax").then(
                (success) => renderDistributorList(success, val),
                (error) => console.log(error),
            );
        });

        jQuery('body').on('click', '.assign-button', function (e) {
            e.preventDefault();
            if (jQuery('.select-company').val() && jQuery('.select-company').val() != "" && jQuery('.select-user').val() && jQuery('.select-user').val() != "") {
                var business = jQuery('.select-company').val();
                var user = jQuery('.select-user').val();
                var csrf = jQuery("[name=csrf-token]").attr('content');
                var data = { 'business_id': business, 'user_id': user, '_token': csrf };
                jQuery.post("/business/" + business + "/distributors/ajax/post", { data: data }).then(
                    (success) => {
                        renderDistributorList(success, business);
                    },
                    (error) => {
                        console.log(error);
                        alert(__('Failed to assign distributor. Please try again.'));
                    },
                );

            }
        });

        jQuery('body').on('click', '.remove-access', function (e) {
            e.preventDefault();
            if (jQuery('.select-company').val() && jQuery('.select-company').val() != "") {
                var business = jQuery('.select-company').val();
                var user = jQuery(this).attr('data-id');
                var csrf = jQuery("[name=csrf-token]").attr('content');
                var data = { 'business_id': business, 'user_id': user, '_token': csrf };
                jQuery.post("/business/" + business + "/distributors/ajax/post/remove", { data: data }).then(
                    (success) => renderDistributorList(success, business),
                    (error) => {
                        console.log(error);
                        alert(__('Failed to remove distributor. Please try again.'));
                    },
                );
            }
        });

        // NEW: Select MSA
        // 1. Log In to Business Group as MSA (first user)
        // 2. Add Edit URL on button
        jQuery('body').on('change', '.select-msa', function () {
            const $msaSelect = jQuery('.select-msa');
            const firstUserUrl = $msaSelect.find(':selected').data('user');
            const $loginButton = $('.select-msa-button');
            const businessGroupIdUrl =  $msaSelect.find(':selected').data('url');
            const $viewBusinessGroupBtn = $('.edit-msa-button');

            // if Business Group has MSA, add to button
            if (firstUserUrl) {
                $loginButton.attr("disabled", false);
                $loginButton.attr("href", firstUserUrl)
            } else {
                $loginButton.attr("disabled", true);
                $loginButton.attr("href", "#");
            }

            // add Business Group link to button
            $viewBusinessGroupBtn.attr("href", businessGroupIdUrl);
        })
    }

    // simple JS phone formatter for blades, to replace the old one
    const formatTelInput = (selector = '.formatted-phone', region = 'US') => {
        const inputs = document.querySelectorAll(selector);
        if (!inputs.length) return;

        inputs.forEach(input => {
            const applyFormat = () => {
                const formatter = new AsYouType(region);
                input.value = formatter.input(input.value);
            };

            // on load
            applyFormat();

            // on input
            input.addEventListener('input', applyFormat);
        });
    };

    // run on load
    formatTelInput();
});
